// js
import SecurityDashboardsDetail from '../../components/analytics/SecurityDashboardsDetail';
import { getSecurityDashboardCategory } from '../../selectors/analytics/securitySelectors';
import { connect } from 'react-redux';


const mapStateToProps = (state, ownProps) => {
  return {
    category: getSecurityDashboardCategory(state, parseInt(ownProps.params.dashboardCategoryId))
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityDashboardsDetail);



// WEBPACK FOOTER //
// ./src/containers/analytics/SecurityDashboardsDetail.js